import apiClient from './axiosClient';

export const eraEnrollmentApi = {

    /*
     * Create ERA Enrollment
     */
    create: async (params) => {

        console.log(
            "ERA ENROLLMENT CREATE PARAMS:",
            JSON.stringify(params)
        );

        const request = {
            reason: params.reason ?? "",

            legalName: params.legalName ?? "",
            dba: params.dba || null,
            tin: params.tin ?? "",
            npi: params.npi ?? "",

            contactName: params.contact ?? "",
            email: params.email ?? "",

            aggregateBy: params.aggregateBy ?? "",
            associateWith: params.associateWith ?? "",
            retrievalMethod: params.eraMethod ?? "",

            clearinghouseName: params.chName || null,
            clearinghouseId: params.chId || null,

            effectiveDate: params.effectiveDate
                //? `${params.effectiveDate}T00:00:00`
                ? `${params.effectiveDate}`
                : null,

            authorizedSigner: params.signer ?? "",
            title: params.title ?? "",
            electronicSignature: params.signature ?? "",

            signatureDate: params.signatureDate
                //? `${params.signatureDate}T00:00:00`
                ? `${params.signatureDate}`
                : null,

            attestation: params.attestation,

            userId: params.userId || null
        };

        console.log(
            "ERA ENROLLMENT API REQUEST:",
            JSON.stringify(request)
        );

        const res = await apiClient.post(
            '/api/provider/SubmitERAEnrollment',
            request
        );

        const data = res?.data;

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []
        };
    },


    /*
     * Get ERA Enrollment by Tax ID
     */
    getByTaxId: async (params) => {

        const res = await apiClient.post(
            '/api/provider/getERAEnrollmentByTaxId',
            {
                taxId: params.taxId,
                userId: params.userId
            }
        );

        const data = res?.data;

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []
        };
    },


    /*
     * Get ERA Enrollment List
     */
    getERAEnrollmentList: async () => {

        const res = await apiClient.get(
            '/api/provider/getERAEnrollmentList'
        );

        const data = res?.data;

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []
        };
    },
    getERAEnrollmentList2: async ({
        searchText = "",
        status = "All",
        sortColumnName = "",
        sortColumnDirection = "",
        startIndex = 0,
        pageSize = 10,
        exportCsv = false,
    } = {}) => {
        const response = await apiClient.get(
            "/api/provider/getERAEnrollmentList2",
            {
                params: {
                    searchText,
                    status: status === "All" ? "" : status,
                    sortColumnName,
                    sortColumnDirection,
                    startIndex,
                    pageSize,
                    exportCsv,
                },
            }
        );

        const result = response?.data;

        return {
            success: result?.Success,
            message: result?.Message,
            data: result?.Data || [],
            totalRecord: result?.TotalRecord || 0,
            statusCounts: result?.StatusCounts || [],
            startIndex: result?.StartIndex || 0,
            pageSize: result?.PageSize || pageSize,
        };
    },


    /*
     * Update ERA Enrollment
     */
    update: async (params) => {

        //console.log(
        //    "ERA ENROLLMENT UPDATE PARAMS:",
        //    JSON.stringify(params)
        //);

        const request = {
            eRAEnrollmentId: params.eRAEnrollmentId,

            reason: params.reason ?? "",

            legalName: params.legalName ?? "",
            dba: params.dba || null,
            tin: params.tin ?? "",
            npi: params.npi ?? "",

            contactName: params.contact ?? "",
            email: params.email ?? "",

            aggregateBy: params.aggregateBy ?? "",
            associateWith: params.associateWith ?? "",
            retrievalMethod: params.eraMethod ?? "",

            clearinghouseName: params.chName || null,
            clearinghouseId: params.chId || null,

            effectiveDate: params.effectiveDate
                //? `${params.effectiveDate}T00:00:00`
                ? `${params.effectiveDate}`
                : null,

            authorizedSigner: params.signer ?? "",
            title: params.title ?? "",
            electronicSignature: params.signature ?? "",

            signatureDate: params.signatureDate
                //? `${params.signatureDate}T00:00:00`
                ? `${params.signatureDate}`
                : null,

            attestation: params.attestation,

            userId: params.userId || null
        };

        //console.log(
        //    "ERA ENROLLMENT UPDATE API REQUEST:",
        //    JSON.stringify(request)
        //);

        const res = await apiClient.post(
            '/api/provider/updateERAEnrollment',
            request
        );

        const data = res?.data;

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []
        };
    },


    /*
     * Get NPI from Tax ID
     */
    getNpiFromTaxId: async (params) => {

        const res = await apiClient.get(
            `/api/provider/getNpiFromTaxId?TaxId=${params?.taxId?.trim()}`
        );

        const data = res?.data;

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []
        };
    },


    /*
     * Get ERA Enrollment Status History
     */
    getStatusHistory: async (eraEnrollmentId) => {

        const response = await apiClient.get(
            `/api/provider/admin/getERAEnrollmentStatusHistory/${eraEnrollmentId}`
        );

        return response.data;
    },


    /*
     * Update ERA Enrollment Status
     */
    updateEraEnrollmentStatus: async (params) => {

        console.log(
            "ERA ENROLLMENT UPDATE STATUS PARAMS:",
            JSON.stringify(params)
        );

        const request = {
            eRAEnrollmentId: params.id,
            status: params.newStatus,
            notes: params.statusNotes
        };

        const res = await apiClient.post(
            '/api/provider/admin/updateERAEnrollmentStatus',
            request
        );

        const data = res?.data;

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []
        };
    },


    /*
     * Get Provider Admins
     */
    getProviderAdmins: async (params = {}) => {

        console.log(
            "GET PROVIDER ADMINS PARAMS:",
            JSON.stringify(params)
        );

        const queryParams = new URLSearchParams();

        if (params.search?.trim()) {
            queryParams.append(
                'search',
                params.search.trim()
            );
        }

        queryParams.append(
            'first',
            String(params.first ?? 0)
        );

        queryParams.append(
            'max',
            String(params.max ?? 20)
        );

        const res = await apiClient.get(
            `/api/provider/admin/users/provider-admins?${queryParams.toString()}`
        );

        const data = res?.data;

        return {
            success: data?.Success,
            message: data?.Message,
            data: data?.Data || []
        };
    }

};
